<template>
  <div class="image-group">
    <!-- 用手柄来控制是否允许拖动 -->
    <draggable
      :handle="draggable ? '.image-group-item' : '.drag-disabled'"
      class="drag-wrapper"
      :class="{ 'grid-4': images.length === 4 }"
      :value="images"
      :move="handleMove"
      @end="onDragEnd"
    >
      <div v-for="(img, groupIndex) in images" :key="img.id" class="image-group-item" :class="img.height > img.width ? 'vertical' : ''">
        <FileLimitDesc v-if="showDesc" v-bind="{ ...imageInfo, width: img.width, height: img.height }">
          <template slot="btn">
            <el-button type="primary" @click="$emit('upload', { assetType: 'image', groupIndex })">选择图片</el-button>
          </template>
        </FileLimitDesc>
        <div v-if="img.width && img.height" class="image-size">
          <span>{{ img.width }}</span>
          <span>x</span>
          <span>{{ img.height }}</span>
        </div>

        <img style="height: 100%" v-if="img.preview_url" :src="img.preview_url" alt="" />
      </div>
    </draggable>
    <div style="width: 100%; padding: 2px 1px">
      <slot name="material-name"></slot>
    </div>
    <span class="badge">
      <el-tag v-if="showBadge" class="badge-index">组图{{ index + 1 }}</el-tag>
      <el-tag v-if="draggable" class="badge-drag">可拖动排序</el-tag>
    </span>

    <i v-if="showRemove" class="remove el-icon-error" @click="$emit('remove')"></i>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import FileLimitDesc from './material-desc.vue'
export default {
  components: { FileLimitDesc, draggable },
  props: {
    images: {
      type: Array,
      required: true
    },
    index: {
      type: Number
    },
    draggable: {
      type: Boolean,
      default: false
    },
    showBadge: {
      type: Boolean,
      default: true
    },
    showRemove: {
      type: Boolean,
      default: true
    },
    showDesc: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  },
  computed: {
    imageInfo() {
      return {
        description: '组图',
        file_size: 1024 * 1,
        file_format: ['JPG', 'PNG']
      }
    }
  },
  methods: {
    handleMove(e) {
      const { index, futureIndex } = e.draggedContext
      this.movingIndex = index
      this.futureIndex = futureIndex
      return false // disable sort
    },
    onDragEnd({ newIndex, oldIndex }) {
      this.futureItem = this.images[this.futureIndex]
      this.movingItem = this.images[this.movingIndex]
      const _images = Object.assign([], this.images)
      _images[this.futureIndex] = this.movingItem
      _images[this.movingIndex] = this.futureItem
      this.$emit('update:images', _images)
    }
  }
}
</script>
<style lang="scss" scoped>
@import './styles.scss';

.image-group {
  position: relative;
  max-width: 528px;
  // margin-bottom: 10px;
  border: 1px solid transparent;

  .drag-wrapper {
    display: grid;
    gap: 4px;
    grid-template-columns: repeat(3, 1fr);
    border: 1px solid transparent;
    border-radius: 2px;
    // 4图分两行每行两个、其他的默认一行三个
    &.grid-4 {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  &-item {
    position: relative;
    // width: calc(33.3% - 10px);
    border: 1px solid transparent;
    text-align: center;
    background-color: #eee;
    border-radius: 4px;
    overflow: hidden;
    width: 100%;

    .image-size {
      position: absolute;
      right: 0;
      bottom: 0;
      font-size: 12px;
      line-height: 16px;
      background: rgba(255, 255, 255, 0.5);
    }

    img {
      width: 100%;
    }

    .desc-txt {
      @include desctext;
    }

    .desc-txt p {
      margin: 0;
      &:first-child {
        margin-bottom: 15px;
      }
    }
    &:hover {
      @include hoverborder;
      cursor: move;
    }
  }

  &:hover {
    border: 1px solid rgb(42, 95, 255);
    .remove {
      display: block;
    }
  }
  .badge {
    @include badge;
    &-drag {
      margin-left: 5px;
    }
  }

  .remove {
    @include remove;
  }
}
</style>
